export const ApiList = {
    // Image_URL
    // IMG_URL : "https://api.treatwalk.com",
    IMG_URL : "https://treatwalkapi.equitysoft.net",
    //AUTH
    LOGIN:"auth/login",
    FORGOT_PASSWORD:"auth/forget-password",
    USER_GET:"base/get",
    GET_STRIKE:"streak/get-restore-requests",
    APPROVE_REJECT_STRIKE:"streak/approve-reject-restore-request",
    GENERAL_DOCS_UPDATE:"/base/up/general_docs/1",
    BLOCK_USER:"/user/block-unblock-user",
    GET_REPORTED_USERS:"/user/get-report-users",
    SEND_NOTIFICATION:"notification/send",
    EDIT_NOTIFICATION:"base/up/admin_notification",
    DASHBOARD_TOTAL_COUNTS:"/user/dashboard",
    //HASHTAG
    HASHTAG_CREATE:"base/in/tags",
    HASHTAG_UPDATE:"base/up/tags",
    HASHTAG_DELETE:"base/up/tags",
    FEEDBACKS:"user/get-survey-list",
    GET_FAQS:"admin/get-faqs",
    ADD_FAQ:"admin/add-faqs",
    EDIT_FAQ:"admin/edit-faqs",
    DELETE_FAQ:"admin/delete-faq",
    GET_COMMENT_REASONS:"base/get",
    ADD_COMMENT_REASON:"base/in/comment_report_reasons",
    EDIT_COMMENT_REASON:"base/up/comment_report_reasons",
    DELETE_COMMENT_REASON:"base/up/comment_report_reasons",
    GET_REPORTED_COMMENTS:"base/get"
}